import React, { useState } from 'react';
import {
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid2,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
} from '@mui/material';
import { useIntl } from 'react-intl';
import { makeStyles } from '@mui/styles';
import styles from './styles';
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import { showGroups } from 'js/actions/groupActions';
import { showMeters } from 'js/actions/meterActions';
import { getReportTotalesStarted } from 'js/actions/reportsActions';
import Swal from 'sweetalert2';
const useStyles = makeStyles(styles);

export default function MeasurementReport() {
  const intl = useIntl();
  const classes = useStyles();
  const dispatch = useDispatch();
  const { register, handleSubmit } = useForm();
  const { user } = useSelector((state) => state.user);
  const { corporatives } = useSelector((state) => state.corporatives);
  const { meters } = useSelector((state) => state.meters);
  let { groups } = useSelector((state) => state.groups);

  const [corporative, setCorporative] = useState();
  const [meter, setMeter] = useState();
  const [group, setGroup] = useState([]);
  const [charge, setCharge] = useState([]);
  const [year, setYear] = useState();
  const [month, setMonth] = useState();
  const [includePrice, setIncludePrice] = useState(false);
  const [blocking, setBlocking] = useState();

  const currYear = new Date().getFullYear();

  const years = [currYear - 3, currYear - 2, currYear - 1, currYear];

  const getSelector = (corp) => {
    if (corp == 1) {
      return (
        <FormControl
          className={classes.textField}
          variant="outlined"
          fullWidth={true}
        >
          <InputLabel id="demo-simple-select-outlined-label">
            {intl.formatMessage({ id: 'app.reports.totReports.corpLbl' })}
          </InputLabel>
          <Select
            id="demo-simple-select-outlined"
            {...register('corporative')}
            labelId="demo-simple-select-outlined-label"
            name="corporative"
            onChange={handleCorporative}
            value={corporative}
            input={
              <OutlinedInput
                label={intl.formatMessage({
                  id: 'app.reports.totReports.corpLbl',
                })}
              />
            }
          >
            {shortCorporatives()?.map((el) => (
              <MenuItem value={el.id} key={el.id}>
                {el.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      );
    }
  };

  const handleCorporative = (corporative) => {
    setCorporative(corporative.target.value);
    setCharge([]);
    setGroup([]);
    getMeters(corporative.target.value);
  };

  const handleMeter = (meter) => {
    setMeter(meter.target.value);
    setGroup([]);
    getGroups(meter.target.value);
    setCharge([]);
  };

  const handleGroup = (group) => {
    setGroup(group.target.value);
  };

  const handleYear = (year) => {
    setYear(year.target.value);
  };

  const handleMonth = (month) => {
    setMonth(month.target.value);
  };

  const handleChangeIncludePrice = () => {
    setIncludePrice(!includePrice);
  };

  function endBlocking() {
    setBlocking(false);

    const Toast = Swal.mixin({
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer);
        toast.addEventListener('mouseleave', Swal.resumeTimer);
      },
    });

    Toast.fire({
      icon: 'success',
      title: 'Reporte Generado Correctamente',
    });
  }

  const getMeters = (corporativeId) => {
    dispatch(showMeters(corporativeId));
  };

  const getGroups = (meterId) => {
    dispatch(showGroups(meterId));
  };

  const onSubmit = () => {
    if (!meter || !group || !charge || !year || !month) {
      Swal.fire({
        title: '',
        text: 'Se requiere seleccionar todos los campos para generar el reporte',
        icon: 'warning',
      });
      return;
    }
    let flagPrice = includePrice ? '1' : '0';
    let urlParam =
      'https://api.metimur.mx/api/report/excel/totals/meter_id/' +
      meter +
      '/group_ids/' +
      group +
      '/year/' +
      year +
      '/month/' +
      month +
      '/' +
      flagPrice;
    setBlocking(true);
    dispatch(getReportTotalesStarted(endBlocking, urlParam));
  };

  const shortCorporatives = () => {
    const shortArray = [...corporatives];
    return shortArray.sort((a, b) =>
      a.name !== b.name ? (a.name < b.name ? -1 : 1) : 0
    );
  };

  return (
    <Box
      width="100%"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'start',
        bgcolor: 'white',
        p: 4,
        borderRadius: 1,
        boxShadow: 1,
      }}
    >
      <form className={classes.form} onSubmit={handleSubmit(onSubmit)}>
        <Grid2 container={true} spacing={3}>
          <Grid2
            size={{ lg: 3, md: 6, xs: 6 }}
            sx={{ display: user.adser ? 'block' : 'none' }}
          >
            {getSelector(user.adser)}
          </Grid2>
          <Grid2 size={{ lg: 3, md: 6, xs: 6 }}>
            <FormControl
              className={classes.textField}
              variant="outlined"
              fullWidth={true}
            >
              <InputLabel id="demo-simple-select-outlined-label">
                {intl.formatMessage({
                  id: 'app.reports.totReports.meterLbl',
                })}
              </InputLabel>
              <Select
                id="demo-simple-select-outlined"
                {...register('meter')}
                labelId="demo-simple-select-outlined-label"
                name="meter"
                onChange={handleMeter}
                value={meter}
                input={
                  <OutlinedInput
                    label={intl.formatMessage({
                      id: 'app.reports.totReports.meterLbl',
                    })}
                  />
                }
              >
                {meters?.map((el) => (
                  <MenuItem value={el.id} key={el.id}>
                    {el.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid2>
          <Grid2 size={{ lg: 3, md: 6, xs: 6 }}>
            <FormControl
              className={classes.textField}
              variant="outlined"
              fullWidth={true}
            >
              <InputLabel id="demo-simple-select-outlined-label">
                {intl.formatMessage({
                  id: 'app.reports.totReports.groupLbl',
                })}
              </InputLabel>
              <Select
                id="demo-simple-select-outlined"
                {...register('group')}
                labelId="demo-simple-select-outlined-label"
                multiple
                name="group"
                onChange={handleGroup}
                value={group}
                input={
                  <OutlinedInput
                    label={intl.formatMessage({
                      id: 'app.reports.totReports.groupLbl',
                    })}
                  />
                }
                renderValue={(selected) => {
                  if (!selected.length) return 'Seleccione grupos'; // Texto por defecto si no hay selección
                  return selected
                    .map((value) => {
                      const groupName = groups.find(
                        (el) => el.id === value
                      )?.name;
                      return groupName ? groupName : '';
                    })
                    .join(', ');
                }}
              >
                {groups?.map((el) => (
                  <MenuItem key={el.id} value={el.id}>
                    <Checkbox checked={group.indexOf(el.id) > -1} />
                    {el.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid2>
          <Grid2 size={{ lg: 3, md: 6, xs: 6 }}>
            <FormControl
              className={classes.textField}
              variant="outlined"
              fullWidth={true}
            >
              <InputLabel id="demo-simple-select-outlined-label">
                {intl.formatMessage({ id: 'app.reports.totReports.yearLbl' })}
              </InputLabel>
              <Select
                id="demo-simple-select-outlined"
                {...register('year')}
                labelId="demo-simple-select-outlined-label"
                name="year"
                onChange={handleYear}
                value={year}
                input={
                  <OutlinedInput
                    label={intl.formatMessage({
                      id: 'app.reports.totReports.yearLbl',
                    })}
                  />
                }
              >
                {years.map((yr) => (
                  <MenuItem value={yr} key={yr}>
                    {yr}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid2>
          <Grid2
            size={{ lg: 3, md: user.adser ? 12 : 6, xs: user.adser ? 12 : 6 }}
          >
            <FormControl
              className={classes.textField}
              variant="outlined"
              fullWidth={true}
            >
              <InputLabel id="demo-simple-select-outlined-label">
                {intl.formatMessage({
                  id: 'app.reports.totReports.monthLbl',
                })}
              </InputLabel>
              <Select
                id="demo-simple-select-outlined"
                {...register('month')}
                labelId="demo-simple-select-outlined-label"
                name="month"
                onChange={handleMonth}
                value={month}
                input={
                  <OutlinedInput
                    label={intl.formatMessage({
                      id: 'app.reports.totReports.monthLbl',
                    })}
                  />
                }
              >
                <MenuItem value="1">
                  {intl.formatMessage({ id: 'app.months.jan' })}
                </MenuItem>
                <MenuItem value="2">
                  {intl.formatMessage({ id: 'app.months.feb' })}
                </MenuItem>
                <MenuItem value="3">
                  {intl.formatMessage({ id: 'app.months.mar' })}
                </MenuItem>
                <MenuItem value="4">
                  {intl.formatMessage({ id: 'app.months.apr' })}
                </MenuItem>
                <MenuItem value="5">
                  {intl.formatMessage({ id: 'app.months.may' })}
                </MenuItem>
                <MenuItem value="6">
                  {intl.formatMessage({ id: 'app.months.jun' })}
                </MenuItem>
                <MenuItem value="7">
                  {intl.formatMessage({ id: 'app.months.jul' })}
                </MenuItem>
                <MenuItem value="8">
                  {intl.formatMessage({ id: 'app.months.ago' })}
                </MenuItem>
                <MenuItem value="9">
                  {intl.formatMessage({ id: 'app.months.sep' })}
                </MenuItem>
                <MenuItem value="10">
                  {intl.formatMessage({ id: 'app.months.oct' })}
                </MenuItem>
                <MenuItem value="11">
                  {intl.formatMessage({ id: 'app.months.nov' })}
                </MenuItem>
                <MenuItem value="12">
                  {intl.formatMessage({ id: 'app.months.dec' })}
                </MenuItem>
              </Select>
            </FormControl>
          </Grid2>
          <Grid2 size={{ lg: 3, md: 12, xs: 12 }} sx={{ display: 'flex' }}>
            <FormControlLabel
              className={classes.textField}
              control={
                <Checkbox
                  checked={includePrice}
                  onChange={handleChangeIncludePrice}
                  name="includePrice"
                  selected={includePrice}
                  color="secondary"
                />
              }
              label={intl.formatMessage({
                id: 'app.reports.totReports.includePrice',
              })}
            />
          </Grid2>
          <Button
            className={classes.signUpButton}
            color="primary"
            size="large"
            type="submit"
            loading={blocking}
            variant="contained"
            loadingPosition="start"
          >
            {blocking
              ? 'Cargando...'
              : intl.formatMessage({
                  id: 'app.reports.totReports.downloadBtn',
                })}
          </Button>
        </Grid2>
      </form>
    </Box>
  );
}
